var _defineProperty = require("/codebuild/output/src1494711140/src/jag-website/node_modules/@babel/runtime/helpers/defineProperty.js");
var _toArray = require("/codebuild/output/src1494711140/src/jag-website/node_modules/@babel/runtime/helpers/toArray.js");
var _toConsumableArray = require("/codebuild/output/src1494711140/src/jag-website/node_modules/@babel/runtime/helpers/toConsumableArray.js");
var _slicedToArray = require("/codebuild/output/src1494711140/src/jag-website/node_modules/@babel/runtime/helpers/slicedToArray.js");
require("core-js/modules/es.object.from-entries.js");
var plugin = require('tailwindcss/plugin');
var merge = require('lodash.merge');
var castArray = require('lodash.castarray');
var styles = require('./styles');
var _require = require('./utils'),
  commonTrailingPseudos = _require.commonTrailingPseudos;
var computed = {
  // Reserved for future "magic properties", for example:
  // bulletColor: (color) => ({ 'ul > li::before': { backgroundColor: color } }),
};
function inWhere(selector, _ref) {
  var className = _ref.className,
    modifier = _ref.modifier,
    prefix = _ref.prefix;
  var prefixedNot = prefix(".not-".concat(className)).slice(1);
  var selectorPrefix = selector.startsWith('>') ? "".concat(modifier === 'DEFAULT' ? ".".concat(className) : ".".concat(className, "-").concat(modifier), " ") : '';

  // Parse the selector, if every component ends in the same pseudo element(s) then move it to the end
  var _commonTrailingPseudo = commonTrailingPseudos(selector),
    _commonTrailingPseudo2 = _slicedToArray(_commonTrailingPseudo, 2),
    trailingPseudo = _commonTrailingPseudo2[0],
    rebuiltSelector = _commonTrailingPseudo2[1];
  if (trailingPseudo) {
    return ":where(".concat(selectorPrefix).concat(rebuiltSelector, "):not(:where([class~=\"").concat(prefixedNot, "\"] *))").concat(trailingPseudo);
  }
  return ":where(".concat(selectorPrefix).concat(selector, "):not(:where([class~=\"").concat(prefixedNot, "\"] *))");
}
function isObject(value) {
  return typeof value === 'object' && value !== null;
}
function configToCss() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref2 = arguments.length > 1 ? arguments[1] : undefined,
    target = _ref2.target,
    className = _ref2.className,
    modifier = _ref2.modifier,
    prefix = _ref2.prefix;
  function updateSelector(k, v) {
    if (target === 'legacy') {
      return [k, v];
    }
    if (Array.isArray(v)) {
      return [k, v];
    }
    if (isObject(v)) {
      var nested = Object.values(v).some(isObject);
      if (nested) {
        return [inWhere(k, {
          className: className,
          modifier: modifier,
          prefix: prefix
        }), v, Object.fromEntries(Object.entries(v).map(function (_ref3) {
          var _ref4 = _slicedToArray(_ref3, 2),
            k = _ref4[0],
            v = _ref4[1];
          return updateSelector(k, v);
        }))];
      }
      return [inWhere(k, {
        className: className,
        modifier: modifier,
        prefix: prefix
      }), v];
    }
    return [k, v];
  }
  return Object.fromEntries(Object.entries(merge.apply(void 0, [{}].concat(_toConsumableArray(Object.keys(config).filter(function (key) {
    return computed[key];
  }).map(function (key) {
    return computed[key](config[key]);
  })), _toConsumableArray(castArray(config.css || {}))))).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      k = _ref6[0],
      v = _ref6[1];
    return updateSelector(k, v);
  }));
}
module.exports = plugin.withOptions(function () {
  var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref7$className = _ref7.className,
    className = _ref7$className === void 0 ? 'prose' : _ref7$className,
    _ref7$target = _ref7.target,
    target = _ref7$target === void 0 ? 'modern' : _ref7$target;
  return function (_ref8) {
    var addVariant = _ref8.addVariant,
      addComponents = _ref8.addComponents,
      theme = _ref8.theme,
      prefix = _ref8.prefix;
    var modifiers = theme('typography');
    var options = {
      className: className,
      prefix: prefix
    };
    for (var _i = 0, _arr = [['headings', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'th'], ['h1'], ['h2'], ['h3'], ['h4'], ['h5'], ['h6'], ['p'], ['a'], ['blockquote'], ['figure'], ['figcaption'], ['strong'], ['em'], ['code'], ['pre'], ['ol'], ['ul'], ['li'], ['table'], ['thead'], ['tr'], ['th'], ['td'], ['img'], ['video'], ['hr'], ['lead', '[class~="lead"]']]; _i < _arr.length; _i++) {
      var _arr$_i = _toArray(_arr[_i]),
        name = _arr$_i[0],
        selectors = _arr$_i.slice(1);
      selectors = selectors.length === 0 ? [name] : selectors;
      var selector = target === 'legacy' ? selectors.map(function (selector) {
        return "& ".concat(selector);
      }) : selectors.join(', ');
      addVariant("".concat(className, "-").concat(name), target === 'legacy' ? selector : "& :is(".concat(inWhere(selector, options), ")"));
    }
    addComponents(Object.keys(modifiers).map(function (modifier) {
      return _defineProperty({}, modifier === 'DEFAULT' ? ".".concat(className) : ".".concat(className, "-").concat(modifier), configToCss(modifiers[modifier], {
        target: target,
        className: className,
        modifier: modifier,
        prefix: prefix
      }));
    }));
  };
}, function () {
  return {
    theme: {
      typography: styles
    }
  };
});